export default {
  formas_de_pago: [],
  formas_de_pago_para_cobro: [],
  total_vendido_blanco: 0,
  asientos_contable: [],
  asiento_contable: null,
  precioVentaManual: true, // Estado inicial
}